import React from 'react';
import { useSelector } from 'react-redux';
import {
  seoStateSelector,
  faqsSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import AboutCity from '@stencil/commonstories/src/components/Seo/about-city/about-city';
import FAQs from '@stencil/commonstories/src/components/Seo/faqs/faqs';

const SeoStaticPagesRight = props => {
  const seoState = useSelector(seoStateSelector);
  const faqs = useSelector(faqsSelector);
  const { h_1_header, page_content = '' } = seoState;

  return (
    <>
      <AboutCity title={h_1_header} longDesc={page_content} isDweb={true} shouldBeH1={true} />
      {faqs && faqs.length > 0 ? <FAQs faqs={faqs} isDweb={true} sector={h_1_header} /> : null}
    </>
  );
};

export default SeoStaticPagesRight;
